module.exports = __webpack_public_path__ + "static/media/ImageClicked.4dab3307.svg";